import React from "react"
import AppLayoutContainer from "@geome/shell-locator-components/lib/containers/appLayout"
import AppLayoutBase from "@geome/shell-locator-components/lib/components/appLayout"
import { translate } from "@geome/intl"
import _ from "lodash"

const AppLayout = (props) => {
  const renderLayout = (viewProps) => {
    return <AppLayoutBase {...viewProps} {...props} translate={translate} />
  }
  return <AppLayoutContainer>{renderLayout}</AppLayoutContainer>
}

export default AppLayout
